<template>
  <a href="#" class="user" to="/users/:user.id" v-on:click="showUser">
    <span class="name">{{user.usernm}}</span>
    <span class="e_mail">{{user.maildrss}}</span>
    <span class="role">{{user.role}}</span>    
    <span class="active_user">{{user.active_user}}</span>    
  </a>
</template>
<script>
export default {
  name: "User",
  props: ['user'],
  methods: {
    showUser(e){
      e.preventDefault();
      this.$router.replace({ name: "UserSingle", params: {userid: this.user.id } })
    }
  }
}
</script>
<style></style>